import { ZeroData, ZeroDataActionType } from 'azure-devops-ui/ZeroData';
import React from 'react';

export interface IBaseActionPresentationProps {
  name: string;
  description: JSX.Element;
  imageName: string;
  onStart: () => void;
}

export interface IActionPresentationProps extends IBaseActionPresentationProps {
  customRender?: (props: IBaseActionPresentationProps) => JSX.Element;
}

export default function ActionPresentation(props: IActionPresentationProps): JSX.Element {
  console.debug("loading Action presentation", props);
  
  if (props.customRender) return props.customRender({ ...props });

  return (
    <ZeroData
      primaryText={props.name}
      secondaryText={props.description}
      imageAltText='Brain'
      imagePath={require(`../img/${props.imageName}`)}
      actionText='Start'
      actionType={ZeroDataActionType.ctaButton}
      onActionClick={(event, item) => props.onStart()}
    />
  );
}
